"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeNodeMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var constants_1 = require("./constants");
var challenge_1 = require("../../../../../reducers/slices/challenge/challenge");
var react_redux_1 = require("react-redux");
var react_2 = require("react");
var NodeListItem = function (_a) {
    var type = _a.type, name = _a.name, category = _a.category, data = _a.data, onClick = _a.onClick;
    return ((0, jsx_runtime_1.jsxs)(react_1.Button, { size: "md", variant: "tertiary", onPress: function () { return onClick({ nodeType: type, nodeName: data.name, category: category }); }, className: "justify-start w-full", children: [data.icon || constants_1.DefaultNodeIcon, (0, jsx_runtime_1.jsx)("p", { children: data.name })] }));
};
var ChallengeNodeMenu = function (_a) {
    var onNodeSelect = _a.onNodeSelect;
    var dispatch = (0, react_redux_1.useDispatch)();
    var nodeModal = (0, react_redux_1.useSelector)(function (state) { return state.challengeState.nodeModal; });
    var NodeList = (0, react_2.useMemo)(function () {
        var categories = Object.entries(constants_1.NodeConfigurations)
            .map(function (_a, index) {
            var category = _a[0], typeConfigs = _a[1];
            if (!typeConfigs || !nodeModal.nodeTypes.includes(category)) {
                return null;
            }
            var nodes = typeConfigs
                .sort(function (a, b) { return a.data.name.localeCompare(b.data.name); })
                .map(function (config, subIndex) {
                var _a, _b, _c;
                var type = config.type, data = config.data;
                var isDisallowed = ((_a = nodeModal.disallowedNodeTypes) === null || _a === void 0 ? void 0 : _a.includes(type)) || ((_b = nodeModal.disallowedNodeTypes) === null || _b === void 0 ? void 0 : _b.includes(category));
                var isExplicitlyAllowed = (_c = nodeModal.allowedNodeTypes) === null || _c === void 0 ? void 0 : _c.includes(type);
                if (!constants_1.nodeTypes[type] || (isDisallowed && !isExplicitlyAllowed)) {
                    return null;
                }
                return ((0, jsx_runtime_1.jsx)(NodeListItem, { type: type, name: data.name, category: category, data: data, onClick: onNodeSelect }, "".concat(category, "-").concat(type, "-").concat(index * 100 + subIndex)));
            })
                .filter(Boolean);
            if (nodes.length === 0) {
                return null;
            }
            return {
                category: category,
                categoryLabel: constants_1.NodeCategoryLabels[category],
                nodes: nodes,
            };
        })
            .filter(Boolean);
        if (!(categories === null || categories === void 0 ? void 0 : categories.length)) {
            return ((0, jsx_runtime_1.jsx)("div", { className: "col-span-2 flex justify-center", children: (0, jsx_runtime_1.jsxs)("p", { className: "text-muted font-medium text-center", children: ["Oops... No nodes found. ", (0, jsx_runtime_1.jsx)("br", {}), " If you think this is an error please contact support."] }) }));
        }
        return categories.map(function (_a) {
            var category = _a.category, categoryLabel = _a.categoryLabel, nodes = _a.nodes;
            return ((0, jsx_runtime_1.jsxs)("div", { className: "contents", children: [(0, jsx_runtime_1.jsx)("div", { className: "col-span-2 mb-2 mt-4 first:mt-0", children: (0, jsx_runtime_1.jsx)("p", { className: "text-muted text-sm font-medium border-b border-default pb-2", children: categoryLabel }) }), nodes.map(function (node, index) { return ((0, jsx_runtime_1.jsx)("div", { className: "w-full", children: node }, "node-wrapper-".concat(category, "-").concat(index))); })] }, "category-section-".concat(category)));
        });
    }, [nodeModal.nodeTypes, onNodeSelect]);
    var overlayState = (0, react_1.useOverlayState)({
        isOpen: true,
        onOpenChange: function (isOpen) { return dispatch((0, challenge_1.setNodeModal)(__assign(__assign({}, nodeModal), { isOpen: isOpen }))); },
    });
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { state: overlayState, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Backdrop, { children: (0, jsx_runtime_1.jsx)(react_1.Modal.Container, { children: (0, jsx_runtime_1.jsxs)(react_1.Modal.Dialog, { children: [(0, jsx_runtime_1.jsx)(react_1.Modal.CloseTrigger, {}), (0, jsx_runtime_1.jsx)(react_1.Modal.Header, { className: "flex flex-col border-b", children: (0, jsx_runtime_1.jsx)(react_1.Modal.Heading, { children: "Nodes" }) }), (0, jsx_runtime_1.jsx)(react_1.Modal.Body, { className: "py-4", children: (0, jsx_runtime_1.jsx)("div", { className: "grid grid-cols-2 gap-3", children: NodeList }) })] }) }) }) }));
};
exports.ChallengeNodeMenu = ChallengeNodeMenu;
